"use client";

import { useEffect, useState, Suspense } from "react";
import ProductGrid from "@/components/gridPage/ProductGrid";
import Loader from "@/components/common/LoaderComponent";
import { fetchAllProductsWithDeals } from "@/api-service/product";
import { Product } from "@/packages/types/products";
import { Button } from "@/components/ui/button";

function CrazyDealsContent() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [search] = useState("");
  const [sort] = useState("discount_desc");

  useEffect(() => {
    const loadProducts = async () => {
      try {
        if (page === 1) {
          setLoading(true);
        } else {
          setLoadingMore(true);
        }
        const res = await fetchAllProductsWithDeals(page, limit, search, sort);
        setTotalPages(res.data.totalPages || 1);
        if (page === 1) {
          setProducts(res.data.products || []);
        } else {
          setProducts((prev) => [...prev, ...(res.data.products || [])]);
        }
      } catch (err) {
        console.error("Error loading products", err);
      } finally {
        setLoading(false);
        setLoadingMore(false);
      }
    };

    loadProducts();
  }, [page, search, sort, limit]);

  if (loading && page === 1) {
    return (
      <div className="flex justify-center py-16">
        <Loader label="Loading deals & offers..." size="lg" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto mt-5 px-5 md:px-0">
      {/* Page Header */}
      <div className="text-center mt-6 mb-6">
        <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight capitalize">
          Deals &amp; Offers
        </h1>
      </div>


      {/* Product Grid (Same as Vendor & Collection pages) */}
      {products.length === 0 ? (
        <div className="flex flex-col items-center py-20 text-center">
          <h2 className="text-lg font-semibold">No Deals Found</h2>
          <p className="text-sm text-gray-500">Check back later for special offers</p>
        </div>
      ) : (
        <ProductGrid products={products} />
      )}

      {/* Load More Button */}
      {page < totalPages && (
        <div className="mt-12 mb-10 flex justify-center">
          <Button
            onClick={() => setPage((prev) => prev + 1)}
            disabled={loadingMore}
            className="px-8 py-3 bg-black hover:bg-gray-800 text-white rounded-full font-medium transition shadow-sm text-sm flex items-center gap-2 cursor-pointer"
          >
            {loadingMore ? (
              <>
                <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                Loading...
              </>
            ) : (
              "Load More"
            )}
          </Button>
        </div>
      )}
    </div>
  );
}

export default function CrazyDealsGrid() {
  return (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading deals &amp; offers...</div>}>
      <CrazyDealsContent />
    </Suspense>
  );
}


